/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FcbUniteActiviteDto
 */
export interface FcbUniteActiviteDto {
    /**
     * 
     * @type {number}
     * @memberof FcbUniteActiviteDto
     */
    idUnite?: number;
    /**
     * 
     * @type {string}
     * @memberof FcbUniteActiviteDto
     */
    anneeAcademique?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FcbUniteActiviteDto
     */
    aaS1?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FcbUniteActiviteDto
     */
    aaS2?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FcbUniteActiviteDto
     */
    abS1?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FcbUniteActiviteDto
     */
    abS2?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FcbUniteActiviteDto
     */
    aiS1?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FcbUniteActiviteDto
     */
    aiS2?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FcbUniteActiviteDto
     */
    ceaS1?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FcbUniteActiviteDto
     */
    ceaS2?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FcbUniteActiviteDto
     */
    cebS1?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FcbUniteActiviteDto
     */
    cebS2?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FcbUniteActiviteDto
     */
    ceiS1?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FcbUniteActiviteDto
     */
    ceiS2?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FcbUniteActiviteDto
     */
    fagS1?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FcbUniteActiviteDto
     */
    fagS2?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FcbUniteActiviteDto
     */
    recyclageS1?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FcbUniteActiviteDto
     */
    recyclageS2?: number | null;
}

/**
 * Check if a given object implements the FcbUniteActiviteDto interface.
 */
export function instanceOfFcbUniteActiviteDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbUniteActiviteDtoFromJSON(json: any): FcbUniteActiviteDto {
    return FcbUniteActiviteDtoFromJSONTyped(json, false);
}

export function FcbUniteActiviteDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbUniteActiviteDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idUnite': !exists(json, 'idUnite') ? undefined : json['idUnite'],
        'anneeAcademique': !exists(json, 'anneeAcademique') ? undefined : json['anneeAcademique'],
        'aaS1': !exists(json, 'aaS1') ? undefined : json['aaS1'],
        'aaS2': !exists(json, 'aaS2') ? undefined : json['aaS2'],
        'abS1': !exists(json, 'abS1') ? undefined : json['abS1'],
        'abS2': !exists(json, 'abS2') ? undefined : json['abS2'],
        'aiS1': !exists(json, 'aiS1') ? undefined : json['aiS1'],
        'aiS2': !exists(json, 'aiS2') ? undefined : json['aiS2'],
        'ceaS1': !exists(json, 'ceaS1') ? undefined : json['ceaS1'],
        'ceaS2': !exists(json, 'ceaS2') ? undefined : json['ceaS2'],
        'cebS1': !exists(json, 'cebS1') ? undefined : json['cebS1'],
        'cebS2': !exists(json, 'cebS2') ? undefined : json['cebS2'],
        'ceiS1': !exists(json, 'ceiS1') ? undefined : json['ceiS1'],
        'ceiS2': !exists(json, 'ceiS2') ? undefined : json['ceiS2'],
        'fagS1': !exists(json, 'fagS1') ? undefined : json['fagS1'],
        'fagS2': !exists(json, 'fagS2') ? undefined : json['fagS2'],
        'recyclageS1': !exists(json, 'recyclageS1') ? undefined : json['recyclageS1'],
        'recyclageS2': !exists(json, 'recyclageS2') ? undefined : json['recyclageS2'],
    };
}

export function FcbUniteActiviteDtoToJSON(value?: FcbUniteActiviteDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idUnite': value.idUnite,
        'anneeAcademique': value.anneeAcademique,
        'aaS1': value.aaS1,
        'aaS2': value.aaS2,
        'abS1': value.abS1,
        'abS2': value.abS2,
        'aiS1': value.aiS1,
        'aiS2': value.aiS2,
        'ceaS1': value.ceaS1,
        'ceaS2': value.ceaS2,
        'cebS1': value.cebS1,
        'cebS2': value.cebS2,
        'ceiS1': value.ceiS1,
        'ceiS2': value.ceiS2,
        'fagS1': value.fagS1,
        'fagS2': value.fagS2,
        'recyclageS1': value.recyclageS1,
        'recyclageS2': value.recyclageS2,
    };
}

